import React from "react";
import { CloseButton } from "./CloseButton";

/**
 * The frame a sheet is spread out in on the shop floor: the station sheet
 * and the floor's "within reach" card. A lightly dimmed shop that keeps
 * ticking behind it (deliberately not a Modal — the floor's own keys stay
 * live), a centered column the sheet sits in, and the ✕ floating off the
 * sheet's corner. The sheet itself — the paper card and everything on
 * it — is the caller's.
 *
 * Clicking the dimmed shop puts the sheet away; the sheet swallows its
 * own clicks. Escape is not bound here: the engine dispatcher's
 * `close-sheet` owns that, backing out one layer at a time (the floor
 * card ahead of the station sheet ahead of the truck card).
 *
 * The frame's z-[35] sits under the top bar's z-40 on purpose, so the
 * journal and menu stay clickable over an open sheet.
 */
export const SheetShell: React.FC<{
  onClose: () => void;
  /** What putting the sheet away is, in the fiction's words. */
  closeLabel: string;
  testId: string;
  children: React.ReactNode;
}> = ({ onClose, closeLabel, testId, children }) => (
  <div
    className="fixed inset-0 z-[35] flex items-center justify-center bg-ink-black/30 p-3 pt-24 pointer-events-auto"
    onClick={onClose}
    data-testid={testId}
  >
    <div
      className="relative max-h-full w-full max-w-md"
      onClick={(event) => event.stopPropagation()}
    >
      <div className="max-h-full overflow-y-auto">{children}</div>
      <CloseButton
        label={closeLabel}
        shortcut="close-sheet"
        onClose={onClose}
      />
    </div>
  </div>
);
